import { addState, flowMax, SimplePropsAdder } from 'ad-hok'
import { getContextHelpers, toObjectKeys } from 'ad-hok-utils'

interface CameFromOnboardingContextValue {
  cameFromOnboarding: boolean
  setCameFromOnboarding: (cameFromOnboarding: boolean) => void
}

const [addCameFromOnboardingContextProviderBase, addCameFromOnboarding] =
  getContextHelpers<CameFromOnboardingContextValue>(
    toObjectKeys(['cameFromOnboarding', 'setCameFromOnboarding'])
  )

export { addCameFromOnboarding }

type AddCameFromOnboardingContextProvider =
  SimplePropsAdder<CameFromOnboardingContextValue>

export const addCameFromOnboardingContextProvider: AddCameFromOnboardingContextProvider =
  flowMax(
    addState('cameFromOnboarding', 'setCameFromOnboarding', false),
    addCameFromOnboardingContextProviderBase
  )
